var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 19a1.5 1.5 0 001.5-1.5V9.121c0-.343-.197-.818-.44-1.06l-2.62-2.622C15.696 5.197 15.221 5 14.878 5H6.5A1.5 1.5 0 005 6.5v11A1.5 1.5 0 006.5 19h11zm-2.875-8h-7.25A.375.375 0 017 10.625v-3.25C7 7.168 7.168 7 7.375 7h7.141c.1 0 .195.04.265.11l.11.109c.06.06.109.179.109.265v3.141a.375.375 0 01-.375.375zM12 17a2 2 0 110-4 2 2 0 010 4z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/media/5a04ef9a38cdb6471b0ad809c30a52cd-Save.svg";
export { SvgSave as ReactComponent };